import { useAtom } from "jotai";
import { loaderProgressAtom } from "@/state/jotai/atom/loaderProgressAtom.ts";
import { ProgressLoaderDataType } from "@/types/types.ts";

function useLoaderProgress(): [
  ProgressLoaderDataType,
  (newValue: ProgressLoaderDataType | ((prev: ProgressLoaderDataType) => ProgressLoaderDataType)) => void
] {
  const [instance, setInstance] = useAtom(loaderProgressAtom);

  return [
    instance,
    setInstance
  ];
}

export default useLoaderProgress;
